import { ButtonBase } from '@material-ui/core';
import classNames from 'classnames';
import PeopleIcon from '@material-ui/icons/People';
import LibraryMusicIcon from '@material-ui/icons/LibraryMusic';
import MoneyIcon from '@material-ui/icons/Money';
import ThumbsUpDownIcon from '@material-ui/icons/ThumbsUpDown';
import React, { useCallback, useEffect, useRef } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useAppRoute } from '~/utils/hooks/useAppRoute';
import css from './styles.module.scss';

interface NavBoxProps {
    background: string;
    title: string;
    link: string;
    icon: String;
}

export const NavBox: React.FC<NavBoxProps> = ({ title, link, background, icon }) => {
    const match = useRouteMatch();
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!ref.current) {
            return;
        }

        ref.current.style.setProperty('--nav-box-bg', background);
    }, [background, ref]);

    const route = useAppRoute();

    const isRouteMatched = useRouteMatch(`${match.path}${link}`);

    const handleClick = useCallback(() => {
        route(`${match.url}${link}`);
    }, [match.url, link, route]);
    const renderSwitch = (parms: any) => {
        switch (parms) {
            case 'PeopleIcon':
                return <PeopleIcon />;
            case 'LibraryMusicIcon':
                return <LibraryMusicIcon />;
            case 'MoneyIcon':
                return <MoneyIcon />;
            case 'ThumbsUpDownIcon':
                return <ThumbsUpDownIcon />;
            default:
                return <PeopleIcon />;
        }
    };

    return (
        <div className={classNames(css.module, isRouteMatched && css.active)} ref={ref}>
            <ButtonBase className={css.sidebarinner} onClick={handleClick}>
                {renderSwitch(icon)}
                <span className={'text font-heading-large'}>{title}</span>
            </ButtonBase>
        </div>
    );
};
